<script>
    import InlineSpinner from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/InlineSpinner.svelte?1733898724801';

    export let size = '2rem';
    export let speed = '0.75s';
    export let color = 'var(--color-text)';
    export let stroke = '0.15rem';
</script>

<div>
    <InlineSpinner {size} {speed} {color} {stroke} />
</div>


<style>
    div {
        text-align: center;
    }
</style>